import dayjs from 'dayjs';
import {stringify} from 'qs';
// import { Platform } from 'react-native';

export const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
}

export const date2monthAndDay = (dateString, months, short) => {
    if (isBlank(dateString)) return '';

    // Split the input date string to extract year, month, and day
    const [year, month, day] = dateString.split("-");

    // Get the month name from the months array (subtract 1 from the month number to get zero-based index)
    const monthName = month != null ? months[parseInt(month, 10) - 1][short == true ? "short" : "name"] : '';

    // Return the formatted date string
    return `${monthName} ${parseInt(day, 10)}`;
}

// date - DD.MM.YYYY
export const date2iso = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return date.split(".").reverse().join('-');  // YYYY-MM-DD
};

// date/dateTime - YYYY-MM-DD/YYYY-MM-DD hh:mm:ss
export const iso2date = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return date.substring(0, 10).split("-").reverse().join('.');  // DD.MM.YYYY
};

// dateTime - YYYY-MM-DD hh:mm:ss
export const iso2time = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return date.substring(11, 19);  // hh:mm:ss
};


// dateTime - YYYY-MM-DD hh:mm:ss
export const iso2dateTime = (isoDateTime) => {
    if (isoDateTime == null || isoDateTime == '') {
        return null;
    }
    return iso2date(isoDateTime) + ' ' + iso2time(isoDateTime);  // DD.MM.YYYY  hh:mm:ss
};

// date - YYYY-MM-DD
export const iso2dayjs = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return dayjs(date);  // dayjs
};

// time - HH:MM
export const time2dayjs = (time) => {
    if (time == null || time == '') {
        return null;
    }
    return dayjs(`1970-01-01T${time}:00`);  // dayjs
};

// time - HH:MM или HH:MM:SS (секунды не учитываются)
export const time2minutes = (time) => {
    if (time == null || time == '') {
        return null;
    }
    return (time.substring(0, 2) * 60) + (time.substring(3, 5) * 1);  // Время переведенное в минуты
    // const time0 = dayjs('1970-01-01T00:00:00');  // dayjs
    // const time1 = dayjs(`1970-01-01T${time}`);  // dayjs
    // return time1.diff(time0, 'minute')  // Время переведенное в минуты
};

// time - в формате dayjs
export const dayjs2time = (time) => {
    if (time == null || time == '') {
        return null;
    }
    return time.format("HH:mm");  // HH:MM
};

// date - в формате dayjs
export const dayjs2iso = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return date.format("YYYY-MM-DD");  // YYYY-MM-DD
};

// date - в формате dayjs
export const dayjs2isoDateTime = (date) => {
    if (date == null || date == '') {
        return null;
    }
    return date.format("YYYY-MM-DD HH:mm:ss");  // YYYY-MM-DD HH:MM:SS
};

// date - в формате YYYY-MM-DD
// month - number from 1 to 12
export const setMonth2iso = (date, month) => {
    if (date == null || date == '') return null;
    if (month == null || month == '' || month < 1 || month > 12) return null;
    let newDate = date.substring(0, 5) + (month < 10 ? "0" + month : month) + date.substring(7, 10)
    let day = date.substring(8, 10) * 1;
    let maxDay = getMaxDay(month, date.substring(0, 4))
    if (day > maxDay) newDate = newDate.substring(0, 8) + maxDay;
    return newDate;  // YYYY-MM-DD
};

// A function that takes a month and a year as parameters and returns the maximum day for that month and year
export const getMaxDay = (month, year) => {
    var lookup = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)) {
        lookup[1] = 29;
    }
    return lookup[(month - 1)];
}

export const stringifyNotEmpty = (obj) => {
    return stringify(obj, {
        skipNulls: true,
        filter: (prefix, value) => {
            if (value == '' || value === null || value == [] || value == {}) {
                return undefined;
            }
            return value;
        },
    });
};

export const generateGuid = () => {
    const data = new Uint32Array(4);
    window.crypto.getRandomValues(data);
    return (
        data[0].toString(16) +
        data[1].toString(16) +
        "-" +
        data[2].toString(16) +
        "-" +
        data[3].toString(16)
    );
};

export const isBlank = (str) => {
    return !isNotBlank(str);
};

export const isNotBlank = (str) => {
    return str != null && ("" + str).trim().length > 0;
};

export const compareObjects = (obj1, obj2) => (JSON.stringify(obj1) === JSON.stringify(obj2));

export const inputNumberFormatter = (value) => value == null ? "" : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

// export const inputNumberParser = (value) => (value) => value.replace(/\$\s?|(,*)/g, '');

export const transformBooleanObjectValues = (originalObject) => {
    const transformedObject = {};

    for (const key in originalObject) {
        const value = originalObject[key];

        if (value === "true" || value === "false") {
            transformedObject[key] = value === "true";
            // } else if (!isNaN(value)) {
            //     transformedObject[key] = Number(value);
        } else {
            transformedObject[key] = value;
        }
    }

    return transformedObject;
};

export const removeQuotationMarks = (str) => str.replace(/^"(.*)"$/, '$1');

// не нужен
// Получить URI картинки локальной по ее имени (без расширения) - считаем что это png
// export const getImageUri = (imageName) => {
//     if (Platform.OS == 'android') {
//         return `android.resource://com.labormind.schedule/drawable/${imageName}`;
//     } else if (Platform.OS == 'web') {
//         return require(`../assets/${imageName}.png`); // не работаает
//     } else {
//         return imageName;
//     }
// };

// truncateString takes two parameters: 
//    str (the string to be truncated) 
//    num (the maximum length). 
// If the length of the string is greater than the specified number, it returns a truncated version with an ellipsis (...); otherwise, it returns the original string.
export const truncateString = (str, num) => {
    // Check if the string length is greater than the specified number
    if (str != null && str.length > num) {
        // Return the truncated string with an ellipsis
        return str.slice(0, num) + '...';
    } else {
        // Return the original string
        return str;
    }
}

export const getValueByPath = (obj, path) => {
    const pathParts = path.split('.'); // Split the path into parts
    let value = obj;

    for (const part of pathParts) {
        if (value && typeof value === 'object' && part in value) {
            value = value[part];
        } else {
            return undefined; // Path not found
        }
    }

    return value;
}